export default __webpack_public_path__ + "static/media/plus.4e180ea0.svg";